import { render, staticRenderFns } from "./QRCodeBody.vue?vue&type=template&id=6735eb14"
import script from "./QRCodeBody.vue?vue&type=script&lang=js"
export * from "./QRCodeBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports